import { render } from "./my-indicator.vue?vue&type=template&id=370a3e5e&ts=true"
import script from "./my-indicator.vue?vue&type=script&lang=ts"
export * from "./my-indicator.vue?vue&type=script&lang=ts"

import "./my-indicator.vue?vue&type=style&index=0&id=370a3e5e&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__